import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var GlobalPreFooterContainer = function GlobalPreFooterContainer(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(GlobalPreFooterContainer.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

GlobalPreFooterContainer.displayName = "GlobalPreFooterContainer";
GlobalPreFooterContainer.propTypes = {
  /**
   * Content, GlobalFooterColumn
   */
  children: PropTypes.node.isRequired
};
export default GlobalPreFooterContainer;